import {IParsedTelegramData} from './telegram.controller';
import {IStation, IDischargeModel} from '../../api/api.types';
import {
	ITelegramComparisonData, 
	ITelegramComparsionDailyDataRow, 
	ITelegramComparisonDataRow, 
	IComparisonData} from './telegram-data-comparison.service';
import {IDailyDataParams, IDailyDataRequest} from '../../api/data-value-api.service';
import {DailyDataService} from './daily-data.service';
import {getDischargeValue} from '../../discharge/utils';
import {IOperationalInputService} from './input.service';
import {IDischargeModelApi} from '../../api/discharge-model-api.service';

import {OnChanges, IChangeIndication} from '../../common/common.types';
import * as moment from 'moment';

export interface IDischargeModelData {
	dischargeModel: IDischargeModel,
	createdDischargeModel: boolean,
	stationId: number
}

export interface IFinalTelegramData {
	dailyDataParams: IDailyDataParams,
	parsedTelegramData: IParsedTelegramData
}

export default class OperationalInputDataProcessingController {
	static $inject = ['dailyDataService', 'operationalInputService', 'dischargeModelApi', '$rootScope'];

	public completedTelegrams: IParsedTelegramData[];
	public telegramDataForProcessing: ITelegramComparisonData[];
	public currentDate: Date;

	// collection of discharge models of all sites
	public dischargeModels: IDischargeModelData[] = [];
	public isDischargeInputManual: boolean = false;
	public isWaterLevelInputManual: boolean = false;
	public createdDischargeModel: boolean;

	onProcessed: (callbackArgs: {
	  telegramsRequiringActionFinalData: IFinalTelegramData[],
	  createdDischargeModel: boolean
	}) => void;

	constructor (
		private dailyDataService: DailyDataService,
		private operationalInputService: IOperationalInputService,
		private dischargeModelApi:IDischargeModelApi,
		private $rootScope: ng.IRootScopeService
	) {
		this.currentDate = new Date;
	}

	$onChanges(changes: IChangeIndication) { 

	  if(changes.hasOwnProperty('telegramDataForProcessing') && changes['telegramDataForProcessing'].currentValue) {
	    this.telegramDataForProcessing = changes['telegramDataForProcessing'].currentValue;

	    this.notifyChanges();
	  }
		
	}

	/**
	 * Serves to update averages.
	 */
	onDailyDataWaterLevelChange(dataRow: ITelegramComparsionDailyDataRow) {
		dataRow.averageCell.newWaterLevel = this.calculateAvgWaterLevel(dataRow);
		this.onDataChange();
	}

	onDailyDataDischargeChange(dataRow: ITelegramComparsionDailyDataRow) {
		dataRow.averageCell.newDischarge = this.calculateAvgDischarge(dataRow);
		this.onDataChange();
	}

	private calculateAvgWaterLevel(dataRow: ITelegramComparsionDailyDataRow) {

	  let waterLevels: number[] = [];

	  if (dataRow.morningCell && dataRow.morningCell.newWaterLevel && !isNaN(dataRow.morningCell.newWaterLevel)) {
	    waterLevels.push(dataRow.morningCell.newWaterLevel);
	  }

	  if (dataRow.eveningCell && dataRow.eveningCell.newWaterLevel && !isNaN(dataRow.eveningCell.newWaterLevel)) {
	    waterLevels.push(dataRow.eveningCell.newWaterLevel);
	  }

	  if(waterLevels.length === 2) {
	  	let sum = 0;

	  	_.forEach(waterLevels, function (discharge: number) {
	  	  sum += discharge;
	  	});

	  	return sum / waterLevels.length;
	  } else {
	  	return null
	  }
	  
	}

	private calculateAvgDischarge(dataRow: ITelegramComparsionDailyDataRow) {

	  let discharges: number[] = [];

	  if (dataRow.morningCell && dataRow.morningCell.newDischarge && !isNaN(dataRow.morningCell.newDischarge)) {
	    discharges.push(dataRow.morningCell.newDischarge);
	  }

	  if (dataRow.eveningCell && dataRow.eveningCell.newDischarge && !isNaN(dataRow.eveningCell.newDischarge)) {
	    discharges.push(dataRow.eveningCell.newDischarge);
	  }

	  if (discharges.length === 2) {
	  	let sum = 0;

	  	_.forEach(discharges, function (discharge: number) {
	  	  sum += discharge;
	  	});

	  	return sum / discharges.length;
	  } else {
	  	return null
	  }
	  
	}

	/**
	 * Stores the selected or created discharge model.
	 */
	onDischargeModelChange(dischargeModel:IDischargeModel, created:boolean, stationId: number, $index: number) {
	  // this.dischargeModel = dischargeModel;
	  this.createdDischargeModel = created;
	  // this.dischargeModelStepValid = dischargeModel != null;
	  	if (dischargeModel != null) {
	  	
	  	  const dischargeModelData: IDischargeModelData = {
	  	  	dischargeModel: dischargeModel,
	  	  	createdDischargeModel: created,
	  	  	stationId: stationId
	  	  }
	  	  let isDischargeModelDataInDischargeModelsList: boolean = false;

	  	  if (this.dischargeModels && this.dischargeModels.length) {
	  	  	this.dischargeModels.forEach((model, index) => {
	  	  		if (model.stationId === stationId) {
	  	  			this.dischargeModels[index] = dischargeModelData;
	  	  			isDischargeModelDataInDischargeModelsList = true;
	  	  		}
	  	  	})
	  	  }
	  	  
	  	  if (!isDischargeModelDataInDischargeModelsList) {
	  	  	this.dischargeModels.push(dischargeModelData)	
	  	  }

	  	  if (this.telegramDataForProcessing && this.telegramDataForProcessing.length) {
	  	  	this.notifyChanges();
	  	  }
	  	}
	  }

	public onDataChange() {
		this.notifyChanges();
	}

	/**
	 * Notifies the parent component with the current processed data.
	 */
	private notifyChanges() {
	  if (this.onProcessed) {
	  	const dailyDataParams = this.generateDailyDataParams();
	    this.onProcessed({
	      telegramsRequiringActionFinalData: dailyDataParams,
	      createdDischargeModel: this.createdDischargeModel
	    });
	  }
	}

	

	private generateDailyDataParams() {
		let processedTelegramData: IFinalTelegramData[] = [];

		this.telegramDataForProcessing.forEach((telegramData) => {
			const telegramDischargeModel = _.filter(this.dischargeModels, (dischargeModel) => { 
			      	return dischargeModel.stationId === telegramData.parsedTelegramData.station.id
			    })[0];

			const telegramDischargeData = telegramData.calculatedTelegramData.dischargeData; 
			const telegramMeteoData = telegramData.calculatedTelegramData.meteoData;
			const formattedDailyData = this.dailyDataService.formatDailyDataRequest(telegramData.comparisonData.dailyData);
			// if telegram requiring actions didn't need daily data correction, set daily data to default
			const dailyData =
				formattedDailyData.length ?
				formattedDailyData : 
				(telegramData.calculatedTelegramData.dischargeData && 
				telegramData.calculatedTelegramData.dischargeData.dailyData);

			// set telegrams daily data to inititaly calculated values
			// if some values had to be processed they will be added in the switch statement below
			let telegramDailyDataParams: IDailyDataParams = {
			  dischargeData: {
			  	date:
			  		telegramDischargeData &&
			  		telegramDischargeData.date,
			    siteId: telegramData.parsedTelegramData.station.id,
			    dailyData: dailyData,
			    temperatures: {
			    	waterTemperature: 
			    		telegramDischargeData &&
			    		telegramDischargeData.temperatures &&
			    		telegramDischargeData.temperatures.waterTemperature ||
			    		telegramDischargeData &&
			    		telegramDischargeData.temperatures &&
			    		(telegramDischargeData.temperatures.waterTemperature === 0 ?
			    		telegramDischargeData.temperatures.waterTemperature : null),
			    	airTemperature: 
			    		telegramDischargeData &&
			    		telegramDischargeData.temperatures &&
			    		telegramDischargeData.temperatures.airTemperature ||
			    		telegramDischargeData &&
			    		telegramDischargeData.temperatures &&
			    		(telegramDischargeData.temperatures.airTemperature === 0 ?
			    		telegramDischargeData.temperatures.airTemperature : null),
			    },
			    icePhenomenae: 
			    	telegramDischargeData &&
			    	telegramDischargeData.icePhenomenae,
			    dischargeModelParams: {
			      dischargeModel: (telegramDischargeModel && telegramDischargeModel.dischargeModel),
			      createdDischargeModel: telegramDischargeModel ? 
			      	telegramDischargeModel.createdDischargeModel : null
			    },
			    dischargeMeasurementData: {
			      waterLevel:
			      	telegramDischargeData &&
			      	telegramDischargeData.dischargeMeasurementData &&
			      	telegramDischargeData.dischargeMeasurementData.waterLevel ||
			      	telegramDischargeData &&
			      	telegramDischargeData.dischargeMeasurementData &&
			      	(telegramDischargeData.dischargeMeasurementData.waterLevel === 0 ?
			      	telegramDischargeData.dischargeMeasurementData.waterLevel : null),
			      discharge:
			      	telegramDischargeData &&
			      	telegramDischargeData.dischargeMeasurementData &&
			      	telegramDischargeData.dischargeMeasurementData.discharge ||
			      	telegramDischargeData &&
			      	telegramDischargeData.dischargeMeasurementData &&
			      	(telegramDischargeData.dischargeMeasurementData.discharge === 0 ?
			      	telegramDischargeData.dischargeMeasurementData.discharge : null),
			      freeRiverArea:
			      	telegramDischargeData &&
			      	telegramDischargeData.dischargeMeasurementData &&
			      	telegramDischargeData.dischargeMeasurementData.freeRiverArea ||
			      	telegramDischargeData &&
			      	telegramDischargeData.dischargeMeasurementData &&
			      	(telegramDischargeData.dischargeMeasurementData.freeRiverArea === 0 ?
			      	telegramDischargeData.dischargeMeasurementData.freeRiverArea : null),
			      maximumDepth: 
			      	telegramDischargeData &&
			      	telegramDischargeData.dischargeMeasurementData &&
			      	telegramDischargeData.dischargeMeasurementData.maximumDepth ||
			      	telegramDischargeData &&
			      	telegramDischargeData.dischargeMeasurementData &&
			      	(telegramDischargeData.dischargeMeasurementData.maximumDepth === 0 ?
			      	telegramDischargeData.dischargeMeasurementData.maximumDepth : null),
			      date: 
			      	telegramDischargeData &&
			      	telegramDischargeData.dischargeMeasurementData &&
			      	telegramDischargeData.dischargeMeasurementData.date ?
			      	telegramDischargeData.dischargeMeasurementData.date : null
			    }
			  },
			  meteoData: {
			    siteId:
			    	telegramMeteoData &&
			    	telegramMeteoData.siteId,
			    month:
			    	telegramMeteoData &&
			    	telegramMeteoData.month,
			    decade:
			    	telegramMeteoData &&
			    	telegramMeteoData.decade,
			    precipitation:
			    	telegramMeteoData &&
			    	telegramMeteoData.precipitation ||
			    	telegramMeteoData &&
			    	(telegramMeteoData.precipitation === 0 ?
			    	telegramMeteoData.precipitation : null),
			    precipitationChecksum:
			    	telegramMeteoData &&
			    	telegramMeteoData.precipitationChecksum ||
			    	telegramMeteoData &&
			    	(telegramMeteoData.precipitationChecksum === 0 ?
			    	telegramMeteoData.precipitationChecksum : null),
			    airTemp:
			    	telegramMeteoData &&
			    	telegramMeteoData.airTemp ||
			    	telegramMeteoData &&
			    	(telegramMeteoData.airTemp === 0 ?
			    	telegramMeteoData.airTemp : null),
			    year:
			    	telegramMeteoData &&
			    	telegramMeteoData.year,
			    currentDate:
			    	telegramMeteoData &&
			    	telegramMeteoData.currentDate
			  }
			};

			// overwrite default telegram's daily data values with processed values
			telegramData.comparisonData.dischargeDataRows.forEach((dischargeDataRow) => { 
				switch (dischargeDataRow.fieldName) {
					case 'discharge':
						telegramDailyDataParams.dischargeData.dischargeMeasurementData.discharge = 
							dischargeDataRow.overrideData ? dischargeDataRow.newValue : dischargeDataRow.oldValue;

						if (dischargeDataRow.manualInputValue) {
							telegramDailyDataParams.dischargeData.dischargeMeasurementData.discharge = 
								dischargeDataRow.manualInputValue;
						}
						break;
					case 'waterLevel':
						telegramDailyDataParams.dischargeData.dischargeMeasurementData.waterLevel =
							dischargeDataRow.overrideData ? dischargeDataRow.newValue : dischargeDataRow.oldValue;

						if (dischargeDataRow.manualInputValue) {
							telegramDailyDataParams.dischargeData.dischargeMeasurementData.waterLevel =
								dischargeDataRow.manualInputValue;
						}
						break;
					case 'freeRiverArea':
						telegramDailyDataParams.dischargeData.dischargeMeasurementData.freeRiverArea =
							dischargeDataRow.overrideData ? dischargeDataRow.newValue : dischargeDataRow.oldValue;

						if (dischargeDataRow.manualInputValue) {
							telegramDailyDataParams.dischargeData.dischargeMeasurementData.freeRiverArea =
								dischargeDataRow.manualInputValue;
						}
						break;
					case 'maximumDepth':
						telegramDailyDataParams.dischargeData.dischargeMeasurementData.maximumDepth =
							dischargeDataRow.overrideData ? dischargeDataRow.newValue : dischargeDataRow.oldValue;

						if (dischargeDataRow.manualInputValue) {
							telegramDailyDataParams.dischargeData.dischargeMeasurementData.maximumDepth =
								dischargeDataRow.manualInputValue;
						}
						break;
					case 'date':
						telegramDailyDataParams.dischargeData.dischargeMeasurementData.date =
							dischargeDataRow.overrideData ? dischargeDataRow.newValue : dischargeDataRow.oldValue;

						if (dischargeDataRow.manualInputValue) {
							telegramDailyDataParams.dischargeData.dischargeMeasurementData.date =
								dischargeDataRow.manualInputValue;
						}
						break;
					case 'waterTemperature':
						telegramDailyDataParams.dischargeData.temperatures.waterTemperature =
							dischargeDataRow.overrideData ? dischargeDataRow.newValue : dischargeDataRow.oldValue;

						if (dischargeDataRow.manualInputValue) {
							telegramDailyDataParams.dischargeData.temperatures.waterTemperature =
								dischargeDataRow.manualInputValue;
						}
						break;
					case 'airTemperature':
						telegramDailyDataParams.dischargeData.temperatures.airTemperature =
							dischargeDataRow.overrideData ? dischargeDataRow.newValue : dischargeDataRow.oldValue;

						if (dischargeDataRow.manualInputValue) {
							telegramDailyDataParams.dischargeData.temperatures.airTemperature =
								dischargeDataRow.manualInputValue;
						}
						break;
				}
			});

			if (
				!telegramData.calculatedTelegramData.meteoData ||
				(telegramData.calculatedTelegramData.meteoData && !telegramData.calculatedTelegramData.meteoData.siteId)
			) {
				delete telegramDailyDataParams.meteoData;
			} else {
				telegramData.comparisonData.meteoDataRows.forEach((meteoDataRow) => {
					switch (meteoDataRow.fieldName) {
						case 'airTemperature':
							telegramDailyDataParams.meteoData.airTemp = 
								meteoDataRow.overrideData ? meteoDataRow.newValue : meteoDataRow.oldValue;

							if (meteoDataRow.manualInputValue) {
								telegramDailyDataParams.meteoData.airTemp = 
									meteoDataRow.manualInputValue;
							}
							break;
						case 'precipitation':
							telegramDailyDataParams.meteoData.precipitation = 
								meteoDataRow.overrideData ? meteoDataRow.newValue : meteoDataRow.oldValue;

							if (meteoDataRow.manualInputValue) {
								telegramDailyDataParams.meteoData.precipitation =
									meteoDataRow.manualInputValue;
							}
							break;
					}
				});
			}

			
			if (
				!telegramDailyDataParams.dischargeData.dischargeMeasurementData.waterLevel &&
				!telegramDailyDataParams.dischargeData.dischargeMeasurementData.discharge &&
				!telegramDailyDataParams.dischargeData.dischargeMeasurementData.freeRiverArea &&
				!telegramDailyDataParams.dischargeData.dischargeMeasurementData.maximumDepth
			) {
				delete telegramDailyDataParams.dischargeData.dischargeMeasurementData;
			}

			if (!telegramData.calculatedTelegramData.dischargeData) {
				delete telegramDailyDataParams.dischargeData;
			}

			telegramData.comparisonData.icePhenomenaeDataRowsList.forEach((icePhenomenaeDataRow, index) => { 
				icePhenomenaeDataRow.forEach((icePhenomenaeItem) => {
					switch (icePhenomenaeItem.fieldName) {
						case 'code':
							telegramDailyDataParams.dischargeData.icePhenomenae[index].code = 
								icePhenomenaeItem.overrideData ? icePhenomenaeItem.newValue : icePhenomenaeItem.oldValue;

							if (icePhenomenaeItem.manualInputValue) {
								telegramDailyDataParams.dischargeData.icePhenomenae[index].code = 
									icePhenomenaeItem.manualInputValue;
							}
							break;
						case 'intensity':
							telegramDailyDataParams.dischargeData.icePhenomenae[index].intensity =
								icePhenomenaeItem.overrideData ? icePhenomenaeItem.newValue : icePhenomenaeItem.oldValue;

							if (icePhenomenaeItem.manualInputValue) {
								telegramDailyDataParams.dischargeData.icePhenomenae[index].intensity =
									icePhenomenaeItem.manualInputValue;
							}
							break;
						}
				})
			});

			processedTelegramData.push({
				dailyDataParams: telegramDailyDataParams,
				parsedTelegramData: telegramData.parsedTelegramData
			});
		})
		return processedTelegramData;
	}
	
	public isDataRowOverrideDisabled(dataRow: ITelegramComparisonDataRow) {
		return dataRow.oldValue === null || typeof dataRow.oldValue === 'undefined';
	}  
}


/** WEBPACK FOOTER **
 ** ./app/operational/input/data-processing.controller.ts
 **/